import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CyklusProduktEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/cyklus-produkt-enum-dto';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { BetalerDialogComponent } from '../betaler-dialog/betaler-dialog.component';

@Component({
    selector: 'app-kunde-info',
    templateUrl: './kunde-info.component.html',
    styleUrls: ['./kunde-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KundeInfoComponent implements OnInit {
  fyringsolieProdukt: CyklusProduktEnumDto = CyklusProduktEnumDto.Fyringsolie;
  gasProdukt: CyklusProduktEnumDto = CyklusProduktEnumDto.Gas;
  elProdukt: CyklusProduktEnumDto = CyklusProduktEnumDto.El;

  @Input() kunde: KundeDto;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  openBetaler() {
    this.dialog.open(BetalerDialogComponent, {
      data: {
        kunde: this.kunde,
      },
    });
  }

  getKundeInfo(): string {
    return (
      this.formatKundeInfo(this.kunde?.okKundeNr) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.name) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.adressLine) +
      this.formatKundeInfo(this.kunde?.lokation) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.contact) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.phone) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.mobile) +
      this.formatKundeInfo(this.kunde?.anlaegsadresse?.email)
    );
  }

  formatKundeInfo(value: any): string {
    return value === null || value === '' ? '' : value.toString() + '\n';
  }
}
